import React, { Component } from 'react';
import ImageTools from '../../helpers/ImageTools';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';
import dataModel from '../../models/DataModel';
import anime from 'animejs';
import WaitSpinner from '../../components/WaitSpinner';

import attachmentsIcon from '../../assets/images/attachment-icon-gray.svg';
import tasksIcon from '../../assets/images/my-tasks-icon-gray.svg';
import cancelIcon from '../../assets/images/cancel-icon-white.svg';

import './CopyTaskPopout.scss';
import CheckBox from '../CheckBox';
import Input from '../Input';
import Textarea from '../Textarea';

const task_flat = {
  task: {
    user_task_assignments: {
      user: {
        additionalFields: ['profile_image'],
        companies: {},
      },
    },
    project: {},
  },
};

const taskDescriptor = {
  task: {
    completion_criteria: {},
  },
};

class CopyTaskPopout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      task: props.task,
      taskDescription: props.task.notes ? props.task.notes : '',
      taskName: props.task.name + ' (Copy)',
      selectedSteps: {},
      isAllChecked: false,
    };

    this.changeTaskInfo = this.changeTaskInfo.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.handleTaskCopy = this.handleTaskCopy.bind(this);
    this.collapsePopup = this.collapsePopup.bind(this);
    this.checkToggled = this.checkToggled.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  componentDidMount() {
    this.handleOffScreen();
  }

  componentDidUpdate(prevProps) {
    const { task } = this.state;

    if (prevProps.displayCopyPopout != this.props.displayCopyPopout && this.props.displayCopyPopout) {
      this.expandPopup();

      dataModel.tasksDAO.getTask(task.id, { recordDescriptor: taskDescriptor }, task => {
        this.setState({ task });
      })
        .then(task => {
          this.setState({ task });
        });
    }
  }

  handleOffScreen() {
    const { task } = this.state;
    const rect = this.copyTaskPopout.getBoundingClientRect();

    //resets popup to anchor at screen bottom if it overlaps window height
    const height = !task.completion_criteria.length ? 255 : 383;
    if ((rect.top + height) > window.innerHeight) {
      let top = this.copyTaskPopout.offsetTop + (window.innerHeight - rect.top - height);
      this.setState({ top });
    }

    //resets popup to anchor at left side of column if it overlaps window width
    const width = this.copyTaskPopout.offsetWidth;
    if ((rect.left + width) > window.innerWidth) {
      this.setState({ left: -260 });
    }
  }

  expandPopup() {
    const { task } = this.state;
    const height = !task.completion_criteria.length ? 255 : 383;
    return anime({
      targets: this.copyTaskPopout,
      height: height,
      easing: 'easeInOutCubic',
      duration: 200,
    });
  }

  collapsePopup() {
    return anime({
      targets: this.copyTaskPopout,
      height: 0,
      easing: 'easeInOutCubic',
      duration: 200,
      complete: () => {
        this.closePopup();
      },
    });
  }
  
  getIconForCSType(completionStep) {
    return ImageTools.getGreyedCSIcon(completionStep, 'grey-outline');
  }

  toggleAll(){
    const value = this.state.isAllChecked;
    if(!value){
      const { task } = this.state;
      let items = {};
      task.completion_criteria.map(cc => {
        items = {
          ...items,
          [cc.id]: cc.id,
        };
      });
      this.setState({ isAllChecked: !value, selectedSteps: items });
    }else {
      this.setState({ isAllChecked: !value, selectedSteps: {} });
    }
  }

  checkToggled(id){
    const { selectedSteps } = this.state;
    let updatedSteps = { ...selectedSteps };
    if(selectedSteps[id]){
      delete updatedSteps[id];
    }else{
      updatedSteps = { ...updatedSteps, [id]: id };
    }
    this.setState({ selectedSteps: updatedSteps });
  }

  createStepsForDisplay() {
    const { task, selectedSteps } = this.state;

    if (typeof task.completion_criteria[0] == 'number') {
      return <WaitSpinner />;
    }
    const steps = task.completion_criteria.map((cc, index) => {
      let className = 'step-item';
      if (index == 0) {
        className += ' step-item--first';
      }
      const src = this.getIconForCSType(cc);
      return (
        <li className={className} key={index}>
          <div>
          <CheckBox checked={selectedSteps[cc.id]} toggleCheckBox={() => {this.checkToggled(cc.id);}}/>
          </div>
          <p>{cc.name.toUpperCase()}</p>
          <img src={src} alt={cc.name}/>
        </li>
      );
    });

    return (
      <ul className='step-list'>
         <div className='step-header'>
          <div><CheckBox checked={this.state.isAllChecked} toggleCheckBox={this.toggleAll}/></div>
          <p className='sub-header'>{this.state.isAllChecked ? 'Deselect All' : 'Select All'}</p>
          </div>
        {steps}
      </ul>
    );
  }

  changeTaskInfo(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  closePopup() {
    const { handleClosePopup } = this.props;
    if (handleClosePopup) {
      handleClosePopup();
    }
  }

  handleTaskCopy(e) {
    e.stopPropagation();
    const { task, taskName, taskDescription, selectedSteps } = this.state;
    if(taskName){
      let selectedTasks = task.completion_criteria.filter(item => selectedSteps[item.id]);
      const newTask = { ...task, ...{ name: taskName }, ...{ notes: taskDescription ? taskDescription : null }, completion_criteria: selectedTasks, completion_criteria_counts: { total: selectedTasks.length, completed: 0, rejected: 0 } };
      dataModel.tasksDAO.copyTask(newTask, task.build_id, null, { recordDescriptor: task_flat }).then(copiedTask =>
        this.props.handleAddCopiedTask(copiedTask, task)
      );
      this.collapsePopup();
      this.analyticsLogger.logTaskAdminEvent(this.props.isFromTemplate ? 'PTQuickActionsTaskCopied' : 'ProjectQuickActionsTaskCopied');
    }
  }

  render() {
    const { task } = this.state;
    const { taskName, taskDescription } = this.state;

    let style = {
      top: this.state.top,
      left: this.state.left,
    };
    if(this.props.isFromTaskCRUD){
      style = {
        left: '64%',
        top: '12%',
      };
    }
    return (
      <article 
        className={'copy-task-popout'}
        ref={el => this.copyTaskPopout = el}
        style={style}
      >
        <header className='copy-task-popout__header'>
          COPY TASK
          <img 
            src={cancelIcon} 
            alt="cancel"
            className='close-button' 
            onClick={this.collapsePopup}
          />
        </header>
        <section className='copy-task-popout__container'>
          <div className='task-info'>
            <p className='task-info__text'>TASK NAME</p>
            <Input 
              className='task-info__input' 
              name='taskName'
              value={taskName}
              onChange={this.changeTaskInfo}
            />
            <div className='task-info__attachments'>
              <div className='icon-container'>
                <img src={attachmentsIcon} alt="Attachments"/>
                <p>{task.reference_documents ? task.reference_documents.length: 0}</p>
              </div>
              <div className='icon-container'>
                <img
                  className='task-count-icon'
                  src={tasksIcon}
                  alt="tasks-count"
                />
                <p>{task.completion_criteria.length}</p>
              </div>
            </div>
            <p className='task-info__text'>TASK DESCRIPTION</p>
            <Textarea
              className='task-info__input task-info__description'
              name='taskDescription'
              value={taskDescription}
              onChange={this.changeTaskInfo}
            />
          </div>
          {
            task.completion_criteria.length > 0 &&
            <div className='step-info'>
              <p className='task-info__text'>COMPLETION STEPS</p>
              {this.createStepsForDisplay()}
            </div>
          }
        </section>
        <div className='copy-task-popout__button-container'>
          <button className='copy-button' onClick={this.collapsePopup}>
            CANCEL
          </button>
          <button
            className={'copy-button copy-button__copy' + (taskName && taskDescription ? '-active' : '')}
            disabled={!(taskName && taskDescription)}
            onClick={this.handleTaskCopy}
          >
            COPY
          </button>
        </div>
      </article>
    );
  }

}

export default CopyTaskPopout;



// WEBPACK FOOTER //
// ./src/components/CopyTaskPopout/index.js